module.exports = __webpack_public_path__ + "static/media/backWave21.3e0514f7.svg";